/**
 * Created by AlexanderC on 6/2/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Factory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Resource = require('./Resource');

var _Collection = require('./Collection');

var _Action = require('./Action');

var _Policy = require('./Policy');

var _Statement = require('./Statement');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  AWS IAM factory
 */
let Factory = exports.Factory = function () {
  function Factory() {
    _classCallCheck(this, Factory);
  }

  _createClass(Factory, null, [{
    key: 'create',

    /**
     * @param {Function|*} Prototype
     * @param {Array} args
     * @returns {Object}
     */
    value: function create(Prototype) {
      Prototype = Factory._assurePrototype(Prototype);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return new (Function.prototype.bind.apply(Prototype, [null].concat(args)))();
    }

    /**
     * @param {Function|*} Prototype
     * @returns {Collection}
     */

  }, {
    key: 'createCollection',
    value: function createCollection(Prototype) {
      Prototype = Factory._assurePrototype(Prototype);

      return new _Collection.Collection(Prototype);
    }

    /**
     * @param {Function|*} Prototype
     * @returns {Function}
     * @private
     */

  }, {
    key: '_assurePrototype',
    value: function _assurePrototype(Prototype) {
      if (typeof Prototype === 'string') {
        Prototype = Factory[Prototype.toUpperCase()];
      }

      return Prototype;
    }

    /**
     * @returns {Policy}
     * @constructor
     */

  }, {
    key: 'POLICY',
    get: function get() {
      return _Policy.Policy;
    }

    /**
     * @returns {Action}
     * @constructor
     */

  }, {
    key: 'RESOURCE',
    get: function get() {
      return _Resource.Resource;
    }

    /**
     * @returns {Resource}
     * @constructor
     */

  }, {
    key: 'ACTION',
    get: function get() {
      return _Action.Action;
    }

    /**
     * @returns {Statement}
     * @constructor
     */

  }, {
    key: 'STATEMENT',
    get: function get() {
      return _Statement.Statement;
    }
  }]);

  return Factory;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Factory.js
// module id = 359
// module chunks = 0